import {FooterType} from "../app/FooterType";
import {PledgerAction} from "@pledger/frontend-commons";
import {PledgerPageComponentState} from "../../services/ui/PledgerPageComponentState";
import {Reducer} from "redux";
import {CurrentModuleId} from "./CurrentModuleId";
import {CreateSouscriptionActions} from "./CreateSouscriptionActions";
import {ShowPageActions} from "../app/Pages/ShowPageActions";
import {
    souscriptionSelfcareReducers,
    SouscriptionSelfcareState
} from "./SouscriptionSelfcare/SouscriptionSelfcareReducers";
import {souscriptionCGPReducers, SouscriptionCGPState} from "./SouscriptionCGP/SouscriptionCGPReducers";

import {
    souscriptionCGPTunnelReducers,
    SouscriptionCGPTunnelState
} from "./SouscriptionCGPTunnel/SouscriptionCGPTunnelReducers";
import {MIOBSPDialogState} from "./MIOBSPDialog/MIOBSPDialog";
import {miobspDialog} from "./MIOBSPDialog/MIOBSPDialogReducer";
import {souscriptionCGPWServiceActions} from "../../services/ws/SouscriptionCGP/souscriptionCGPWServiceActions";
import {
    AssetAccountTypeJSON,
    PartnerJSON
} from "../../services/ws/SouscriptionCGP/dto/SimulationReferencesResponseJSON";


const footerType = (state = FooterType.NONE, action : PledgerAction) => {
    switch (action.type) {
        default:
            return FooterType.NONE;
    }
};

const pageLoaded = (state = false, action : PledgerAction) => {
    switch (action.type) {
        case souscriptionCGPWServiceActions.GET_SOUSCRIPTION_CGP_REFERENCES_SUCCEEDED_ACTION.type:
            return true;

        default:
            return state;
    }
};

const warrantyPartners = (state = [], action : PledgerAction) => {
    switch (action.type) {
        case souscriptionCGPWServiceActions.GET_SOUSCRIPTION_CGP_REFERENCES_SUCCEEDED_ACTION.type:
            return action.payload.data.partners;

        default:
            return state;
    }
};

const accountTypes = (state = [], action : PledgerAction) => {
    switch (action.type) {
        case souscriptionCGPWServiceActions.GET_SOUSCRIPTION_CGP_REFERENCES_SUCCEEDED_ACTION.type:
            return action.payload.data.assetAccountTypes;

        default:
            return state;
    }
};

const navigationMenuEnabled = (state = true, action : PledgerAction) => {
    switch (action.type) {
        default:
            return true;
    }
};

const moduleToDisplayId = (state = CurrentModuleId.MAIN, action : PledgerAction) => {
    switch (action.type) {
        case CreateSouscriptionActions.SELECT_MODULE_TO_DISPLAY_ACTION.type:
            return action.payload.moduleId;
        case ShowPageActions.SHOW_CREATE_SOUSCRIPTION_ACTION.type:
            return CurrentModuleId.MAIN;
        default:
            return state;
    }
};

export interface CreateSouscriptionPageComponentState extends PledgerPageComponentState {
    pageLoaded: boolean;
    moduleToDisplayId: CurrentModuleId;
    souscriptionSelfcare:SouscriptionSelfcareState;
    souscriptionCGP:SouscriptionCGPState;
    souscriptionCGPTunnel:SouscriptionCGPTunnelState;
    warrantyPartners : PartnerJSON[];
    accountTypes : AssetAccountTypeJSON[];
    miobspDialog: MIOBSPDialogState;
}

export const createSouscription : Reducer = (state={}, action)=>{
    return{
        footerType: footerType(state.footerType, action),
        pageLoaded: pageLoaded(state.pageLoaded, action),
        navigationMenuEnabled: navigationMenuEnabled(state.navigationMenuEnabled, action),
        moduleToDisplayId: moduleToDisplayId(state.moduleToDisplayId, action),
        warrantyPartners : warrantyPartners(state.warrantyPartners, action),
        accountTypes : accountTypes(state.accountTypes, action),
        souscriptionSelfcare:souscriptionSelfcareReducers(state.souscriptionSelfcare, action),
        souscriptionCGP:souscriptionCGPReducers(state.souscriptionCGP, action),
        souscriptionCGPTunnel:souscriptionCGPTunnelReducers(state.souscriptionCGPTunnel, action),
        miobspDialog:miobspDialog(state.miobspDialog,action),
    }
}
